import { Box, Stack, Typography } from '@mui/material'
import React from 'react'
import SkillCard from './SkillCard'

const Skills = (props) => {
  return (
    <Box p={5} mx={'auto'} width={'80%'}>
        <Typography variant='h5'  color={'#F2F2F2'} fontWeight={'bold'}>{props.type}</Typography>
        <Stack direction={"row"} sx={{justifyContent:{sm:'flex-start',md:'space-evenly'}, overflowX:'auto'}} marginTop={3}>
            {props.items.map((item,idx)=>
                <SkillCard key={idx} item={item}/>
            )}
        </Stack>
    </Box>
  )
}

export default Skills